const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "invitation/SET_INVITATION":
      return {
        ...state,
        [action.invitationUUID]: {
          ...state[action.invitationUUID],
          result: action.payload,
        },
      }
    case "invitation/SET_LOADING":
      return {
        ...state,
        [action.invitationUUID]: {
          ...state[action.invitationUUID],
          loading: action.payload,
        },
      }
    case "invitation/SET_ERROR":
      return {
        ...state,
        [action.invitationUUID]: {
          ...state[action.invitationUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
